import React from "react";
import {SyncStatus} from "@/data/entities/sync";
import {Badge} from "peggirkit";
import {BadgeColorScheme} from "peggirkit/dist/components/Badge/BadgeElements/BadgeStyles";
import {FormattedMessage, useIntl} from "react-intl";

type StatusToBadgeColorMap = {
    [key in SyncStatus]: BadgeColorScheme;
};

const statusToBadgeColorMap: StatusToBadgeColorMap = {
    "IDLE": "secondary",
    "IDLE_AFTER_ERROR": "danger",
    "SYNCHRONIZING": "warning",
}

type Props = {
    status: SyncStatus
};

const StatusFormatter = ({status}: Props) => {
    const intl = useIntl();

    return (
        <Badge
            aria-label={intl.formatMessage({id: "currentStatus"})}
            color={statusToBadgeColorMap[status]}
        >
            <FormattedMessage id={`syncStatus.${status}`}/>
        </Badge>
    );
};

export default StatusFormatter;